/* Others */
import { makeFetchActionCreators, makeFetchActionTypes } from "../../../utils";

export const ACTION_TYPES_BASE_NAME = "pdp/continueWatching";

const actionCreators = makeFetchActionCreators(ACTION_TYPES_BASE_NAME);

export const { fetch: fetchPdpContinueWatching } = actionCreators;
export const actionTypes = makeFetchActionTypes(ACTION_TYPES_BASE_NAME);
